import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { UtilsService } from 'src/core/services/utils.service';

@Component({
    selector: 'app-error-details',
    templateUrl: './error-details.component.html',
    styleUrls: ['./error-details.component.scss'],
    standalone: false
})
export class ErrorDetailsComponent implements OnInit {

  errors: string [] = [];
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<ErrorDetailsComponent>,
    private _utilService: UtilsService
  ) { }

  ngOnInit(): void {
    this._utilService
    .errors()
    .subscribe((errors) => {
      this.errors = errors;
    });
  }

  close() {
    this._bottomSheetRef.dismiss();
  }

}
